module.exports = __webpack_public_path__ + "img/vmc_aniv13_24Aug2021.5c16da1e.jpg";